import { TemplateData, TemplateParams } from '.';

const pathCompleted = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.completionEmailPathCompletionSuccess}
        ${messages.completionEmailUserContent2}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.completionEmailUserHeading,
    subject: `{{siteName}}: ${messages.completionPathCompleted}`
  },
  placeholders: {
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathUrl: {
      label: messages.pathsPathLink,
      example: `${serverConfig.adminUrl}/paths/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathCompleted
});

export default pathCompleted;
